<script setup lang="ts">
import {onMounted, ref} from "vue";
import {useStore} from "./store";
import DetailsScreen from "./components/DetailsScreen.vue";
import PlayerComponent from "./components/PlayerComponent.vue";
import PreviewScreen from "./components/PreviewScreen.vue";
import ShareComponent from "./components/ShareComponent.vue";
import RateComponent from "./components/RateComponent.vue";
import SignInComponent from "./components/SignInComponent.vue";
import ActionNotification from "./components/ActionNotification.vue";

const store = useStore();
const notification = ref<{ [name: string]: string } | null>(null)
store.fetchContentItem(store.itemId)
    .then((contentItem) => {
        if (!contentItem)
            return;
        const langCode = contentItem.languages.filter((row) => row.selected).pop()?.code
        if (langCode){
            window.postMessage({e: "language-switch", lang: langCode})
        }
    })

function clearNotification(){
    notification.value = null;
}

onMounted(() => {
    document.querySelector<HTMLElement>("body")?.addEventListener("notify", function(e: CustomEvent){
        if (e.detail?.message && e.detail?.type){
            notification.value = {
                message: e.detail.message,
                type: e.detail.type,
            }

            setTimeout(clearNotification, 1500)
        }
        // eslint-disable-next-line no-undef
    } as EventListener);
})
</script>

<template>
    <DetailsScreen v-if="store.page === 'details'" @toggle="store.toggleModal"></DetailsScreen>
    <PlayerComponent v-else-if="store.page === 'player'"></PlayerComponent>
    <PreviewScreen v-else-if="store.page === 'preview'"></PreviewScreen>
    <ShareComponent v-if="store.modal === 'share'" @toggle="store.toggleModal"></ShareComponent>
    <RateComponent v-if="store.modal === 'rate'" @toggle="store.toggleModal" ></RateComponent>
    <SignInComponent v-if="store.modal === 'sign-in'" @toggle="store.toggleModal"></SignInComponent>
    <ActionNotification v-if="notification" :message="notification.message" :type="notification.type"></ActionNotification>
</template>
